import { withTranslationReady } from "common/i18n/withTranslationReady";
import React from "react";

const InvestmentTasks = () => {
  return <p data-testid="investment-tasks">This is where actionable tasks will appear.</p>;
};

export default withTranslationReady(["client"])(InvestmentTasks);
